import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Observable } from 'rxjs';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { toArray } from 'src/app/services/util/utils';
import { PermissionRule } from 'src/app/models/principal/permission-rule';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {

  constructor(private authService: AuthService, private errorPageService: ErrorPageService) {

  }

  canActivate(activated: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const permissionRule = (activated.data as any)?.permissionRule as PermissionRule;
    if (permissionRule) {
      let hasPermission = false;
      if (permissionRule.allOf) {
        hasPermission = toArray(permissionRule.allOf).every(permission => this.authService.hasPermission(permission));
      } else if (permissionRule.anyOf) {
        hasPermission = toArray(permissionRule.anyOf).some(permission => this.authService.hasPermission(permission));
      } else if (permissionRule.not) {
        hasPermission = !toArray(permissionRule.not).some(permission => this.authService.hasPermission(permission));
      } else {
        throw new Error(`Permission is missing for route "${state.url}". Either add permission rule or remove permission guard.`);
      }

      if (!hasPermission) {
        this.errorPageService.show404Page();
      }
      return hasPermission;
    }

    // If permissions guard is added then there should be permission.
    throw new Error(`Permission is missing for route "${state.url}". Either add permission rule or remove permission guard.`);
  }
}
